import { helper } from '@ember/component/helper';
import { sanitizeInlineHtml } from './safe-string.js';

/**
 * MAP (in-file navigation graph — keep in sync with the code):
 *   role:      helper — {{safe-inline-html text}}: tenant HTML reduced to links + inline formatting (allowlist,
 *              safe-string.js sanitizeInlineHtmlString); for consent / privacy labels
 *   siblings:  safe-string (blocklist sanitizer for rich content)
 *   tests:     tests/unit/helpers/safe-inline-html-test.js
 */
var safeInlineHtml = helper(([string]) => sanitizeInlineHtml(string));

export { safeInlineHtml as default };
//# sourceMappingURL=safe-inline-html.js.map
